// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper__c26 {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: calc(var(--ring-unit) * 3);

  .messageRow__c8e.messageRow__c8e {
    display: grid;
    grid-template-columns: 12px auto;

    &:first-of-type {
      margin-top: var(--ring-unit);
    }
  }

  .massageDot__d5c {
    margin-top: var(--ring-unit);
    content: '';
    width: var(--ring-unit);
    height: var(--ring-unit);
    border: 1px solid var(--ring-text-color);
    border-radius: 50%;
    background-color: var(--ring-text-color);
  }

  .message__ca1.message__ca1 {
    position: relative;
    line-height: var(--ring-line-height-taller);
  }

  .messageRow__c8e:not(:last-child) .message__ca1::before {
    content: '';
    width: calc(var(--ring-unit) * 0.5);
    height: calc(100% + var(--ring-unit) * 0.5);
    position: absolute;
    background-color: var(--ring-text-color);
    opacity: 0.15;
    top: calc(var(--ring-unit) * 2.75);
    left: calc(var(--ring-unit) * -3.5);
    transform: translateX(-50%);
  }

  .massageDot__d5c + .message__ca1 {
    margin-left: calc(var(--ring-unit) * 2.5);
  }
}
`, "",{"version":3,"sources":["webpack://./src/common/popup-message/popup-stepped-message/popup-stepped-message.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,+BAA+B;;EAE/B;IACE,aAAa;IACb,gCAAgC;;IAEhC;MACE,4BAA4B;IAC9B;EACF;;EAEA;IACE,4BAA4B;IAC5B,WAAW;IACX,uBAAuB;IACvB,wBAAwB;IACxB,wCAAwC;IACxC,kBAAkB;IAClB,wCAAwC;EAC1C;;EAEA;IACE,kBAAkB;IAClB,2CAA2C;EAC7C;;EAEA;IACE,WAAW;IACX,mCAAmC;IACnC,2CAA2C;IAC3C,kBAAkB;IAClB,wCAAwC;IACxC,aAAa;IACb,kCAAkC;IAClC,mCAAmC;IACnC,2BAA2B;EAC7B;;EAEA;IACE,yCAAyC;EAC3C;AACF","sourcesContent":[".wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: calc(var(--ring-unit) * 3);\n\n  .messageRow.messageRow {\n    display: grid;\n    grid-template-columns: 12px auto;\n\n    &:first-of-type {\n      margin-top: var(--ring-unit);\n    }\n  }\n\n  .massageDot {\n    margin-top: var(--ring-unit);\n    content: '';\n    width: var(--ring-unit);\n    height: var(--ring-unit);\n    border: 1px solid var(--ring-text-color);\n    border-radius: 50%;\n    background-color: var(--ring-text-color);\n  }\n\n  .message.message {\n    position: relative;\n    line-height: var(--ring-line-height-taller);\n  }\n\n  .messageRow:not(:last-child) .message::before {\n    content: '';\n    width: calc(var(--ring-unit) * 0.5);\n    height: calc(100% + var(--ring-unit) * 0.5);\n    position: absolute;\n    background-color: var(--ring-text-color);\n    opacity: 0.15;\n    top: calc(var(--ring-unit) * 2.75);\n    left: calc(var(--ring-unit) * -3.5);\n    transform: translateX(-50%);\n  }\n\n  .massageDot + .message {\n    margin-left: calc(var(--ring-unit) * 2.5);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `wrapper__c26`,
	"messageRow": `messageRow__c8e`,
	"massageDot": `massageDot__d5c`,
	"message": `message__ca1`
};
export default ___CSS_LOADER_EXPORT___;
